export default "__VITE_ASSET__BjwdBKBx__"